<script>
	import { makeBodyScrollable } from '$lib/util/util';
	import AdjustMargin from './Margin/AdjustMargin.svelte';
	import ClosePosition from './closePosition/ClosePosition.svelte';
	import CreateScWallet from './createSCWallet/CreateSCWallet.svelte';
	import { popupModalData, popupModalOpen, popupModalType } from './popupsStore';
	import Tos from './tos/TOS.svelte';
	import ShareablePnL from '$lib/home/userHoldings/ShareablePnL.svelte';
	import { scale } from 'svelte/transition';
	import { quadInOut } from 'svelte/easing';
	import DepositFundsModal from './createSCWallet/DepositFundsModal.svelte';
	import TPSL from './TPSL/TPSL.svelte';
	import ConfirmAddAuthorityPopup from '$lib/home/scwallet/otherdetails/ConfirmAddAuthorityPopup.svelte';
	import WalletFound from './WalletFound/WalletFound.svelte';
	import Wallet from './wallet/Wallet.svelte';
	import ViewAllTokensAndMargins from './viewAllTokensAndMargins/ViewAllTokensAndMargins.svelte';
	import ReferralPopup from '$lib/referral/ReferralPopup.svelte';
	import { page } from '$app/stores';
	import { validateReferralCode } from '$lib/apis/referral';
	import { walletAddress, walletConnected } from '$lib/wallet/store';
	import JoinClanPopup from '$lib/clanWars/JoinClanPopup.svelte';
	import OpenOrb from './OpenOrb/OpenOrb.svelte';
	import LevelNftClaimed from './LevelNftClaimed/LevelNftClaimed.svelte';
	import AnimatedBackground from './animatedBackground.svelte';
	import { orbToOpenInModal, userMysteryOrbs } from '$lib/tradingSeason/store';
	import MysteryOrbPopup from '$lib/tradingSeason/MysteryOrbsSection/MysteryOrbPopup.svelte';

	function closeNotificationModal() {
		$popupModalOpen = false;
		makeBodyScrollable();
	}

	// Check for referral code in URL and open referral popup if present
	$: referralCode = $page.url.searchParams.get('referral') || '';

	const checkIfReferralIsValid = async () => {
		const res = await validateReferralCode(referralCode, $walletAddress);
		if (!res) return;

		popupModalType.set('AcceptReferral');
		popupModalOpen.set(true);
	};

	$: if (referralCode && $walletAddress) {
		checkIfReferralIsValid();
	}
</script>

{#if $popupModalOpen}
	<div
		class="bg-fx-black bg-opacity-50 firefox:bg-opacity-50 modal fixed w-full h-full flex justify-center top-0 left-0 backdrop-filter z-[90] backdrop-blur place-items-center"
		transition:scale|global={{
			duration: 100,
			delay: 0,
			opacity: 0.9,
			start: 0.97,
			easing: quadInOut
		}}
	>
		<div class="fixed sm:relative w-full sm:w-fit z-[100] h-fit bottom-auto flex justify-center">
			{#if $popupModalType === 'AdjustMargin'}
				<AdjustMargin />
			{:else if $popupModalType === 'ClosePosition'}
				<ClosePosition />
			{:else if $popupModalType === 'CreateWallet'}
				<CreateScWallet />
			{:else if $popupModalType === 'Tos'}
				<Tos />
			{:else if $popupModalType === 'WalletFound'}
				<WalletFound />
			{:else if $popupModalType === 'SharePnL'}
				<ShareablePnL marketIdentifier={$popupModalData} />
			{:else if $popupModalType === 'DepositFunds'}
				<DepositFundsModal
					title="Your Polynomial Wallet Doesn't Have Funds"
					minDepositNeeded="50"
				/>
			{:else if $popupModalType === 'TPSL'}
				<TPSL />
			{:else if $popupModalType === 'ConfirmAddAuthority'}
				<ConfirmAddAuthorityPopup />
			{:else if $popupModalType == 'DepositWallet'}
				<Wallet selectedAction="Deposit" />
			{:else if $popupModalType == 'WithdrawWallet'}
				<Wallet selectedAction="Withdraw" />
			{:else if $popupModalType == 'ViewAllTokenBalances'}
				<ViewAllTokensAndMargins selectedAction="Token Balance" />
			{:else if $popupModalType == 'ViewAllMarginBalances'}
				<ViewAllTokensAndMargins selectedAction="Margin Balance" />
			{:else if $popupModalType == 'AcceptReferral'}
				<ReferralPopup />
			{:else if $popupModalType == 'JoinClan'}
				<JoinClanPopup />
			{:else if $popupModalType == 'OpenOrb'}
				<OpenOrb />
			{:else if $popupModalType == 'LevelNftClaimed'}
				<LevelNftClaimed />
			{:else if $popupModalType == 'MysteryOrb'}
				<MysteryOrbPopup />
			{/if}
		</div>
		<button
			on:click={closeNotificationModal}
			on:keydown={closeNotificationModal}
			class="w-full h-full fixed z-10"
		/>
		{#if ($popupModalType == 'OpenOrb' && $userMysteryOrbs.find((orb) => orb.id === $orbToOpenInModal)?.claimedAt) || $popupModalType == 'LevelNftClaimed'}
			<AnimatedBackground />
		{/if}
	</div>
{/if}
